import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../button/button";

// import "./NavigationItems.css";
import "./initiatives.css";

function ConferencesItems(props) {
  return (
    <li>
      <div className="initiatives-item">
        <div className="initiative-top">
          <h3>{props.name}</h3>
          <p>{props.description}</p>
        </div>
        <div>
          {props.isAuth && (
            <>
              <Button design="flat" mode="danger" onClick={props.onDelete}>
                Delete
              </Button>
              <Button design="flat" onClick={props.onStartEdit}>
                Edit
              </Button>
            </>
          )}
        </div>
      </div>
    </li>
  );
  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default ConferencesItems;
